import dateFns from 'date-fns';
import { fiflboxApi } from '@/utils/api';

const state = {
  childMembership: {
    balance: null,
    consumed: null,
    end: null,
    id: null,
    parent_courses: [],
    start: null
  },
  attendableCourses: null,
  attendanceResult: {
    membership: null,
    name: null,
    start: null,
    end: null,
    balance: null,
    consumed: null,
    remainder: null
  },
  member: {
    name: ''
  }
};

const mutations = {
  setAttendableCourses(state, attendableCourses) {
    state.attendableCourses = attendableCourses;
  },
  setChildMembership(state, childMembership) {
    state.childMembership = childMembership;
  },
  setAttendanceResult(state, result) {
    state.attendanceResult = result;
  },
  setCheckedMember(state, member) {
    state.member = member;
  },
  resetCheckInData() {
    state.attendableCourses = null;
    state.childMembership = {
      balance: null,
      consumed: null,
      end: null,
      id: null,
      parent_courses: [],
      start: null
    };
  }
};

const getters = {
  getAttendableCourses(state) {
    return state.attendableCourses;
  },
  getAttendanceResult(state) {
    return state.attendanceResult;
  },
  getChildMembershipForAttend(state) {
    return state.childMembership;
  },
  getCheckedMember(state) {
    return state.member;
  }
};

const actions = {
  async getMembersByCode({ commit, dispatch, store }, memberCode) {
    try {
      const { data } = await fiflboxApi.v2.getRegisters({
        member_code: memberCode,
        status: 'APPROVAL'
      });

      return data;
    } catch (err) {
      throw err;
    }
  },
  async getMemberships({ commit, dispatch, store }, member) {
    const currentTime = new Date();
    const dateString = dateFns.format(currentTime, 'YYYY-MM-DD');

    try {
      const { data } = await fiflboxApi.v2.getChildMemberships({
        enrollment: member.id,
        valid_at: dateString
      });

      return data;
    } catch (err) {
      throw err;
    }
  },
  async syncAttendableCourses({ commit, dispatch, store }, payload) {
    const isBookablePlan = [0, 2].includes(this.getters.getCenterAccount.plan);
    const currentTime = new Date();
    const dateString = dateFns.format(currentTime, 'YYYY-MM-DD');
    const api = isBookablePlan ? fiflboxApi.v1 : fiflboxApi.v2;
    try {
      const { data } = await api.getChildCourses({
        date_after: dateString,
        date_before: dateString,
        child_membership: payload.childMembershipId
      });
      const courses = data[dateString] || [];

      const attendableCourses = courses
        .filter(course => {
          const courseEndTime = dateFns.addMinutes(course.dt, course.duration);

          return dateFns.isAfter(courseEndTime, currentTime);
        })
        .sort((a, b) => dateFns.compareAsc(a.dt, b.dt));

      commit('setAttendableCourses', attendableCourses);
    } catch (err) {
      throw err;
    }
  },
  async attendCourse({ commit, dispatch, store }, payload) {
    try {
      const { data } = await fiflboxApi.v1.postBookingAttendances({
        child_course: payload.childCourseId,
        child_membership: state.childMembership.id
      });

      commit('setAttendanceResult', data);
    } catch (err) {
      throw err;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
